$(document).ready(function(){
    // Handle the click event on the Read More / Read Less link
    $('.toggle-content').click(function() {
        var $moreContent = $(this).siblings('.more');
        var $this = $(this);
        if ($moreContent.hasClass('expanded')) {
            $moreContent.animate({height: '90px'}, 500, function() {
                $this.text('Read More');
                $moreContent.removeClass('expanded');
            });
        } else {
            $moreContent.animate({height: $moreContent.get(0).scrollHeight}, 500, function() {
                $this.text('Read Less');
                $moreContent.addClass('expanded');
            });
        }
    });
});